import Vue from 'vue'
import Vuex from 'vuex'
//import * as fb from '@/config/firebase.js'

Vue.use(Vuex)

import {
    delay
} from '@/variables.js'
export const store = new Vuex.Store({
    state: {
        devMode: false,
        isMobile: false,
        isOriented: false,
        inSpaceship: false,
        database: {
            chat_msgs: null,
            console_news: null
        },
        toPlace: '...',
        wanerMsg: null,
        focusedOnStuff: false,
        user: null

    },
    mutations: {
        setToMobile(state) {
            state.isMobile = true
        },
        setOriented(state) {
            state.isOriented = true
        },
        setAllChatMsgs(state, msgs) {
            state.database.chat_msgs = msgs
        },
        setToPlace(state, toPlace) {
            state.toPlace = toPlace
        },
        setToDevMode(state) {
            state.devMode = true
        },
        getInSpaceship(state) {
            state.inSpaceship = true
        },
        getOutSpaceship(state) {
            state.inSpaceship = false
        },
        setWanerMsg(state, msg) {
            delay(500).then(() => {
                state.wanerMsg = msg.text
                delay(msg.delay).then(() => {
                    if (state.wanerMsg == msg.text) state.wanerMsg = null
                })
            })
        },
        destroyWanerMsg(state) {
            state.wanerMsg = null
        },
        focusOnStuff(state){
            state.focusedOnStuff = !state.focusedOnStuff
        },
        setAnonymousUser(state, user) {
            state.user = user
        }
    },
    actions: {},
    getters: {
        isMobile: state => state.isMobile,
        isOriented: state => state.isOriented,
        toPlace: state => state.toPlace,
        devMode: state => state.devMode,
        inSpaceship: state => state.inSpaceship,
        wanerMsg: state => state.wanerMsg,
        isFocusedOnStuff: state => state.focusedOnStuff
    }
})